<template>
    <div>
        <div class="text-left">
            <h3 class="mb-3">{{$t('cal_Position_Size')}}</h3>
            <p>{{$t('cal_position_txt')}}</p>
        </div>
        <div class="verticallyTab mt-5"> 
            <div class="bottomTab w-100">
                <div class="stepForm-contact mt-5">
                    <div class="row">
                        
                        <div class="col-12 col-md-4">
                            <div class="form-group field-wrapper">
                                <select class="selectpicker float-field form-control" @change="currencyList()" v-model="segm" v-validate="'required'" name="segm" :class="{ 'is-invalid': submitted && errors.has('segm'), 'active' : segm != '' }" onclick="this.setAttribute('value', this.value);" value="">
                                   <!--  <option value=""></option> -->
                                    <option value="Forex">{{$t('cal_marg_forex')}}</option>
                                    <option value="Commodities">{{$t('cal_marg_commodities')}}</option>
                                    <option value="INDICIES">{{$t('cal_marg_indices')}}</option>
                                    <!--<option>Crypto</option>-->
                                </select>
                                <label class="float-label">Asset Class</label>
                                <p class="error" v-if="submitted" v-for="error in errors.collect('segm')">{{$t('cal_position_Field_req')}}</p>
                            </div>
                        </div>
                        <div class="col-12 col-md-4">
                            <div class="form-group field-wrapper">
                                <select class="selectpicker float-field form-control" v-model="basecurreny" v-validate="'required'" name="basecurreny" :class="{ 'is-invalid': submitted && errors.has('basecurreny'), 'active': basecurreny != '' }" onclick="this.setAttribute('value', this.value);" value="">
                                   <!--  <option value=""></option> -->
                                    <option value="USD">{{$t('cal_comm_USD')}}</option>
                                    <option value="GBP">{{$t('cal_comm_GBP')}}</option>
                                    <option value="AUD">{{$t('cal_comm_AUD')}}</option>
                                    <option value="EUR">{{$t('cal_comm_EUR')}}</option>
                                </select>
                                <label class="float-label">{{$t('cal_position_accBaseCurr')}}</label>
                                <p class="error" v-if="submitted" v-for="error in errors.collect('basecurreny')">{{$t('cal_position_Field_req')}}</p>
                            </div>
                        </div>
                        <div class="col-12 col-md-4">
                            <div class="form-group field-wrapper">
                                <select class="selectpicker float-field form-control" v-model="selectedSymbol" v-validate="'required'" name="selectedSymbol" :class="{ 'is-invalid': submitted && errors.has('selectedSymbol'), 'active' : selectedSymbol != '' }" onclick="this.setAttribute('value', this.value);" value="">
                                    <!-- <option value=""></option> -->
                                    <option v-for="spreads in isins" :value="spreads">{{spreads}}</option>
                                </select>
                                <label class="float-label">{{$t('cal_position_Symbol')}}</label>
                                <p class="error" v-if="submitted" v-for="error in errors.collect('selectedSymbol')">{{$t('cal_position_Field_req')}}</p>
                            </div>
                        </div>
                        <div class="col-12 col-md-12">
                            <div class="form-group field-wrapper text-left">
                                <label class="float-label-custom">{{$t('cal_position_Position_Type')}}</label>
                                <div class="d-flex align-items-center mb-3">
                                    <label class="customRadio-button m-0 mr-2">{{$t('cal_position_BUY')}}
                                        <input type="radio"  class="form-control" value="B" v-model="orderType" v-validate="'required'" name="orderType" :class="{ 'is-invalid': submitted && errors.has('orderType') }">
                                        <span class="checkmark"></span>
                                    </label>
                                    <label class="customRadio-button m-0">{{$t('cal_position_SELL')}}
                                        <input type="radio"  class="form-control" value="S" v-model="orderType" v-validate="'required'" name="orderType" :class="{ 'is-invalid': submitted && errors.has('orderType') }">
                                        <span class="checkmark"></span>
                                    </label>
                                    <p class="error" v-if="submitted" v-for="error in errors.collect('orderType')">{{$t('cal_position_Field_req')}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4">
                            <div class="form-group field-wrapper">
                                <input placeholder=" " type="text" class="float-field form-control" v-model="openPrice" v-validate="{ required: true,decimal:10}" name="openPrice" :class="{ 'is-invalid': submitted && errors.has('openPrice') }">
                                <label class="float-label">{{$t('cal_position_Open_Price')}}</label>
                                <p class="error" v-if="submitted" v-for="error in errors.collect('openPrice')">{{$t('cal_position_Field_req')}}</p>
                            </div>
                            <div class="form-group field-wrapper">
                                <input placeholder=" " type="text" class="float-field form-control" v-model="accBalance" v-validate="{ required: true,decimal:10}" name="accBalance" :class="{ 'is-invalid': submitted && errors.has('accBalance') }">
                                <label class="float-label">{{$t('cal_position_Account_Balance')}} </label>
                                <p class="error" v-if="submitted" v-for="error in errors.collect('accBalance')">{{$t('cal_position_Field_req')}}</p>
                            </div>
                        </div> 
                        <div class="col-12 col-md-4">
                            <div class="form-group field-wrapper">
                                <input placeholder=" " type="text" class="float-field form-control" v-model="SLPrice" v-validate="{ required: true,decimal:10}" name="SLPrice" :class="{ 'is-invalid': submitted && errors.has('SLPrice') }">
                                <label class="float-label">{{$t('cal_position_Stop_Loss')}}</label>
                                <p class="error" v-if="submitted" v-for="error in errors.collect('SLPrice')">{{$t('cal_position_Field_req')}}</p>
                            </div>
                            <div class="form-group field-wrapper">
                                <input placeholder=" " type="text"  class="float-field form-control" v-model="riskperc" v-validate="'required'" name="riskperc" :class="{ 'is-invalid': submitted && errors.has('riskperc') }">
                                <label class="float-label">{{$t('cal_position_Risk_Perc')}}</label>
                                <p class="error" v-if="submitted" v-for="error in errors.collect('riskperc')">{{$t('cal_position_Field_req')}}</p>
                            </div>
                        </div> 
                        <div class="col-12 col-md-12">
                            <div class="form-group field-wrapper">
                                <a href="#" class="common_btn" v-on:click.prevent="calculatePS()">{{$t('cal_position_Now')}}</a>
                                <p class="mt-3">{{$t('cal_position_trade_size_lot')}}: {{positionSize}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    export default {
        name: 'PositionSize',
        mixins: [fxViewMixins],
        data() {
            return {
                "isins":'',
                "segm": 'Forex',
                "tradesize": 0,
                "selectedSymbol":"",
                "selectedSeg":"",
                "openPrice": 0,
                "basecurreny":'USD',
                "accBalance":0,
                "SLPrice":0,
                "riskperc": "0",
                "orderType": "B",
                "positionSize":0,
				submitted : false,
                allIsins:''
            }
        },
        created(){
            this.currencyList()
        },
        methods:{
            currencyList(){
                this.isinList=""
                this.allIsins = this.$store.getters['/GET_ISINS_LIST'];
                this.isins = Object.keys(this.allIsins).filter(key => this.allIsins[key].type === this.segm);
                return this.isins;
            },
            calculatePS(){
				const _that = this
                this.submitted = true;
                this.$validator.validate().then(valid => {
                    if (valid) {
						let positionSizeCal=""
                        let BuySellPrice = 0   
                        let firstCurrency=''
                        let selectedCurrecy= this.allIsins[_that.selectedSymbol] 
                        let priceFeed= this.$store.getters['/GET_PRICEFEED_DATA'];
                        let fetchedSelectedSymbol= ''
                        const match = _that.selectedSymbol.match(/\((.*?)\)/); // Regex to find text within brackets
                        if (match) {
                            fetchedSelectedSymbol = match[0]; // Get the content inside the brackets
                        }else {
                            fetchedSelectedSymbol = _that.selectedSymbol; // No brackets found
                        }  
                        let selectedIsinPrice= priceFeed[fetchedSelectedSymbol]
                        if(_that.orderType == 'B'){                
                            BuySellPrice = _that.openPrice-_that.SLPrice                  
                        }else if(_that.orderType == 'S'){                
                            BuySellPrice = _that.SLPrice - _that.openPrice
                        }
                        positionSizeCal= parseFloat(((_that.riskperc/100)*_that.accBalance)/(BuySellPrice*selectedCurrecy.Contract_Size*selectedIsinPrice.A))
                    
                        if(_that.segm =='Shares'){
                            firstCurrency="USD"
                        }else{
                            if(_that.selectedSymbol.includes('.') || _that.selectedSymbol.includes('(')){
                                if(_that.selectedSymbol.includes('.')){
                                    let lastSymbol=_that.selectedSymbol.trim('.')
                                    firstCurrency = lastSymbol.slice('3','6')
                                }else if(_that.selectedSymbol.includes('(')){
                                    let lastSymbol=_that.selectedSymbol.split('(')[0]
                                    firstCurrency = lastSymbol.slice('3','6')
                                }
                            }else if(_that.selectedSymbol.includes('-')){
                                let lastSymbol=_that.selectedSymbol.replace('-', '')
                                firstCurrency = lastSymbol.slice('3','6')
                            }else{                            
                                firstCurrency = _that.selectedSymbol.slice('3','6')
                            }
                        }
                    
                        if(firstCurrency == _that.basecurreny){
                            let secCurrencyPrice = 1
                            _that.positionSize= positionSizeCal*secCurrencyPrice                
                        }else{
                            let secondaryCurrencyPrice = priceFeed[firstCurrency+_that.basecurreny] 
                            if(secondaryCurrencyPrice){
                                _that.positionSize = secondaryCurrencyPrice.A*positionSizeCal
                            }else if(priceFeed[_that.basecurreny+firstCurrency]){
                                secondaryCurrencyPrice = priceFeed[_that.basecurreny+firstCurrency]
                                _that.positionSize = (1/secondaryCurrencyPrice.A)*positionSizeCal
                            }else{   
                                let allIsinList = []
                                let filteredIsins=[]
                                let secondPrice=''
                                allIsinList= Object.keys(this.allIsins)
                                filteredIsins = allIsinList.filter(val=>val.includes(firstCurrency)&&val.includes("USD"))
                                let filteredIsinsSecond=[]
                                filteredIsinsSecond = allIsinList.filter(val=>val.includes(_that.basecurreny))
                                let filteredIsinsSecondPrice= priceFeed[filteredIsinsSecond[0]]
                                secondPrice= 1/filteredIsinsSecondPrice.A
                                filteredIsins.forEach(val=>{
                                    if(val.slice(0,3)=='USD'){
                                    let price= priceFeed['USD'+firstCurrency]
                                    _that.positionSize= (price.A*secondPrice)*positionSizeCal
                                    }else if(val.slice(3,6)){
                                    let price= priceFeed[firstCurrency+'USD']
                                    _that.positionSize= (price.A*secondPrice)*positionSizeCal
                                    }
                                })
                            }
                        }
					}
				})
            }
        },
        computed: {
            fetchedIsins(){
                let isinData= this.$store.getters['/GET_ISINS_LIST'];                 
				return isinData;
			}
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/shared/calculators/position_size.vue